<template>
  <div class="container_box">
    <div class="u-myflex u-j-center u-flexwrap">
      <div
        class="db-border car-my-imgbox"
        v-for="(data, key) in imageList"
        :key="'id' + key"
      >
        <div class="db-border-inline small_container my-detail">
          <slot name="header" v-bind:item="{ data: data, key: key }"></slot>
          <div class="box_shadow">
            <div
              class="img-container u-text-center"
              style="height: 220px"
              @dblclick="showitem(data)"
            >
              <img
                style="width: 100%; height: 100%; cursor: pointer"
                :src="data.img || '../img/no_car_images.png'"
              />
            </div>
            <!-- 车型不符 -->
            <div
              v-show="showlistitem.includes('cxbf')"
              class="w-flex-div"
              style="color: #fff"
            >
              <div style="text-align: left; background: rgb(45, 157, 193); padding: 6px">
                <div>车身颜色：{{ data.carColorName }}</div>
                <div>车辆类型：{{ data.vehicleTypeName }}</div>
                <div>车辆品牌：{{ data.vendorCode }}</div>
              </div>
              <div style="text-align: left; background: rgb(221, 178, 26); padding: 6px">
                <div>抓拍：{{ data.protoCarColor }}</div>
                <div>抓拍：{{ data.protovehicleType }}</div>
                <div>抓拍：{{ data.protoCarBrand }}</div>
              </div>
            </div>
            <!-- 车辆类型 -->
            <div
              v-show="showlistitem.includes('vehicleType')"
              style="padding: 4px 0; font-size: 16px; text-align: right"
            >
              <span style="padding: 6px">{{ data.vehicleType || "" }}</span>
            </div>
            <!-- 信息 -->
            <div style="padding: 12px">
              <div class="u-myflex u-a-center u-j-sb">
                <div
                  style="font-weight: bold; padding: 4px 0; font-size: 16px; width: 50%"
                  class="u-line-1"
                  v-if="showlistitem.includes('plateNumber')"
                >
                  <!-- <img style="padding-right: 4px" src="../img/re_show_01.jpg" /> -->
                  <!-- 多车牌号码提示，数据为数组 -->
                  <el-popover
                    placement="top-start"
                    width="185"
                    trigger="hover"
                    v-if="
                      Object.prototype.toString.call(data.plateNumber) ===
                      '[object Array]'
                    "
                  >
                    <div>
                      <span
                        :class="[item.color || '']"
                        class="cmdlist-card"
                        style="padding: 2px 6px; font-size: 16px"
                        v-for="(item, index) in data.plateNumber"
                        :key="index"
                      >
                        {{ item.num || "" }}
                      </span>
                    </div>
                    <el-badge :value="data.plateNumber.length" class="item">
                      <span slot="reference">{{ data.plateNumber[0].num }}</span>
                    </el-badge>
                  </el-popover>

                  <span
                    :class="[data.plateColor ? 'cmdlist-card' + data.plateColor : '']"
                    class="cmdlist-card"
                    v-else
                    >{{ data.plateNumber || "" }}</span
                  >
                </div>
                <div style="text-align: right" v-if="showlistitem.includes('elecPlate')">
                  <span
                    :class="[data.plateColor ? 'cmdlist-card' + data.plateColor : '']"
                    class="cmdlist-card"
                  >
                    {{ data.elecPlate || "" }}
                  </span>
                </div>

                <!-- 更多卡片 -->
                <el-badge
                  :value="data.moreCard || 0"
                  class="item u-m5-r-2"
                  v-else-if="showlistitem.includes('moreCard')"
                >
                  <div
                    @click="dialogVisible = true"
                    style="cursor: pointer; padding: 4px 0; text-align: right"
                  >
                    更多卡片<i style="font-size: 12px" class="el-icon-d-arrow-right"></i>
                  </div>
                </el-badge>
              </div>
              <div style="padding: 4px 0" v-show="showlistitem.includes('name')">
                 {{ data.name || "陌生人"}}
              </div>
              <div style="padding: 4px 0" v-show="showlistitem.includes('cartime')">
                {{ data.cartime || data.time || "" }}
              </div>
              <div style="padding: 4px 0" v-show="showlistitem.includes('vendorCode')">
                <span class="u-font-weight">品牌:</span>{{ data.vendorCode || "" }}
              </div>
              <div
                style="padding: 4px 0"
                v-show="showlistitem.includes('cardcollect')"
                class="u-myflex"
              >
                <span class="u-flex-11 u-text-l">
                  <span>{{ data.cardcollectName || "卡口地址" }}:</span>
                  {{ data.tollgate || data.address || "" }}
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div
        v-for="item in 3"
        class="empty-db-border car-my-imgbox"
        :key="'empty' + item"
      ></div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    imageList: {
      type: Array,
      default: () => [],
    },
    showlistitem: {
      //单项图片下显示的栏目
      type: Array,
      default: () => {
        //电子车牌'elecPlate'和更多卡片'moreCard'两者二选一显示
        return [
          "plateNumber", //车牌号码
          "elecPlate", //电子车牌号码
          "moreCard", //更多按钮
          "cartime", //过车时间或时间
          "vendorCode", //车辆品牌
          "cardcollect", //卡口地址
          "cxbf", //标签页面 不符专有
          "vehicleType", //车辆类型
        ];
      },
    },
  },
  data() {
    return {
      dialogVisible: false, //点击更多卡片弹窗
    };
  },
  methods: {
    showitem(data) {
      this.$emit("carshow", data);
    },
  },
};
</script>

<style lang="scss">
.el-popover {
  border: 1px solid rgba($color: #b2b2b2, $alpha: 1);
}
.el-popper[x-placement^="top"] .popper__arrow {
  border-top-color: rgba($color: #b2b2b2, $alpha: 1);
}
.db-border {
  padding: 1px;
  margin: 4px;
  margin-bottom: 10px;
  border-radius: 6px;
  outline: solid 2px #016ae0;
  border: solid 2px transparent;
}
.container_box {
  max-width: 1600px;
  .empty-db-border {
    @extend .db-border;
    outline-color: transparent;
  }
  .car-my-imgbox {
    width: 320px;
  }
  .small_container {
    background-color: rgba(0, 0, 0, 0.6);
    width: 100%;
    height: 350px;

    .box_shadow {
      box-shadow: 0 10px 10px rgba(0, 0, 0, 0.2);
      // background-color: #1c3470;
      border-radius: 6px;
      overflow: hidden;
      .el-badge__content.is-fixed {
        top: 15px;
        right: 0px;
      }
      .w-flex-div {
        display: flex;

        > div {
          flex: 1;
        }
      }
    }
  }
  .my-detail *:not(.cmdlist-card) {
    color: #e1e1e1;
  }
}
.h-dialog {
  .tollstationtable {
    width: 98%;
    text-align: center;
    border-spacing: 0;
    border-collapse: collapse;
    th,
    td {
      border: 1px solid rgb(66, 66, 66);
      padding: 4px 6px;
      line-height: 24px;
    }
  }

  .el-dialog__header {
    background: #20222a;
  }

  .el-dialog__headerbtn .el-dialog__close {
    color: #fff;
  }

  .el-dialog__body {
    padding: 0px;
  }

  .el-dialog__title {
    color: #fff;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/carImgList.vue